import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Lightbulb, Settings, Cpu, LineChart } from 'lucide-react';
const services = [{
  icon: Lightbulb,
  title: 'Vertrieb neu denken',
  items: ['Analyse bestehender Vertriebsstrukturen', 'Entwicklung moderner Sales-Strategien', 'Go-to-Market Strategien', 'Zielgruppen-Schärfung']
}, {
  icon: Settings,
  title: 'Effizienz & Prozesse',
  items: ['Automatisierung von Vertriebsprozessen', 'Reduktion manueller Aufwände', 'Pipeline-Management', 'Sales Cycle Optimierung']
}, {
  icon: Cpu,
  title: 'Technologie & KI',
  items: ['CRM-Auswahl & Optimierung', 'KI-gestützte Lead-Qualifizierung', 'Sales Stack Integration', 'Datengetriebene Steuerung']
}, {
  icon: LineChart,
  title: 'Enablement & Umsetzung',
  items: ['Operative Begleitung', 'Sales Playbooks & Skripte', 'Team-Onboarding & Training', 'Kein PowerPoint-Theater']
}];
export function Services() {
  return <Section id="services" background="light" data-id="element-121">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-122">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-123">
          Unsere Leistungen
        </h2>
        <p className="text-lg text-slate-600" data-id="element-124">
          Ganzheitliche Lösungen für die Herausforderungen im modernen
          B2B-Vertrieb.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-125">
        {services.map((service, index) => <Card key={index} className="h-full flex flex-col" data-id="element-126">
            <div className="w-12 h-12 bg-slate-100 rounded-sm flex items-center justify-center mb-6 text-slate-900 group-hover:bg-emerald-600 group-hover:text-white transition-colors" data-id="element-127">
              <service.icon className="w-6 h-6" data-id="element-128" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-129">
              {service.title}
            </h3>
            <ul className="space-y-3 flex-1" data-id="element-130">
              {service.items.map((item, i) => <li key={i} className="flex items-start text-slate-600" data-id="element-131">
                  <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-132"></span>
                  <span data-id="element-133">{item}</span>
                </li>)}
            </ul>
          </Card>)}
      </div>
    </Section>;
}